import { NoteRoute } from '@/modules/note/v1/api/NoteRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { RemoveFilesParams } from '@/modules/note/v1/api/v1/files/Dto/RemoveFilesParams'
import { RemovedFiles } from '@/modules/note/v1/api/v1/files/Dto/RemovedFiles'

/** DELETE /api/note/v1/notes/{note}/files {files}: удалить файлы заметки на узле */
export class RemoveFilesRoute extends NoteRoute<RemoveFilesParams, RemovedFiles> {
  constructor(private readonly note: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.DELETE
  }

  url(): string {
    return '/api/note/v1/notes/' + this.note + '/files'
  }

  offline(params: RemoveFilesParams): Promise<ApiResponse<RemovedFiles>> {
    return Promise.resolve(new ApiResponse({ success: true, data: new RemovedFiles({ removed: params.files }) }))
  }
}
